export function filterChips(root = document) {
    const groups = root.querySelectorAll('.filter-chips');
    if (!groups.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
        });
    }, { threshold: 0.1 });

    groups.forEach(group => {
        group.querySelectorAll('.filter-chip').forEach((chip, index) => {
            chip.style.setProperty('--filter-chip-index', index);
        });
        group.classList.add('is-reveal-ready');
        observer.observe(group);
    });

    return () => {
        observer.disconnect();
        groups.forEach(group => {
            group.classList.remove('is-reveal-ready', 'is-revealed');
            group.querySelectorAll('.filter-chip').forEach(chip => {
                chip.style.removeProperty('--filter-chip-index');
            });
        });
    };
}
